// extracted by mini-css-extract-plugin
export default {"playingOverlay":"PlayingOverlay_playingOverlay__7bmJI","fire":"PlayingOverlay_fire__M9Glw","grow":"PlayingOverlay_grow__5V5VP"};